const produkte = [
{   
        url: 'https://onlineshop.haribo.com/goldbaeren?number=4001686322840',
        name: 'HARIBO Goldbären'

},
{   
        url: 'https://onlineshop.haribo.com/tropifrutti1000g',
        name: 'HARIBO TropiFrutti'

},
{   
        url: 'https://onlineshop.haribo.com/haribo/fruchtgummi/1261/pico-balla',
        name: 'HARIBO Pico-Balla'

},
{   
        url: 'https://onlineshop.haribo.com/detail/index/sArticle/2260',
        name: 'HARIBO Pico-Balla Sauer'

},
{   
        url: 'https://onlineshop.haribo.com/phantasia',
        name: 'HARIBO Phantasia'
},
{   
        url: 'https://onlineshop.haribo.com/color-rado175g',
        name: 'HARIBO Color-Rado'
}
]

export default produkte;
